exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\na[data-v-74de9bb8] {\r\n  color: #000;\r\n  white-space: pre;\n}\r\n", ""]);

// exports
